import React from 'react';
import './PilotProgramPage.css';

// Import images
import childrenImage from '../assets/images/children-1311506_1920.jpg';
import teacherImage from '../assets/images/teacher-4784917_1920.jpg';

const PilotProgramPage = ({ onNavigate }) => {
  return (
    <div className="pilot-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="logo-container">
                <img 
                  src="https://static.wixstatic.com/media/1d90b3_588e219d6cc2449d84256529ea18235d~mv2.png" 
                  alt="Digital Flourishing for Young Minds" 
                  className="page-logo"
                />
              </div>
              <h1>Join Our Pilot Program</h1>
              <p className="hero-description">
                Join our pilot program to be a pioneer in transforming your school's digital culture. 
                We're seeking forward-thinking educational institutions ready to lead the way in 
                digital wellness and student wellbeing.
              </p>
              <button className="btn btn-primary" onClick={() => onNavigate('contact')}>
                Apply for the Pilot Program
              </button>
            </div>
            <div className="hero-image">
              <img src={childrenImage} alt="Children engaged in collaborative learning" />
            </div>
          </div>
        </div>
      </section>

      {/* What is the Pilot Program */}
      <section className="section section-white">
        <div className="container">
          <div className="section-header text-center">
            <h2>What is the Digital Flourishing Pilot Program?</h2>
            <p>
              Our pilot program offers selected schools the opportunity to implement our comprehensive 
              Digital Flourishing framework with enhanced support, research collaboration, and 
              significant cost savings.
            </p>
          </div>

          <div className="pilot-features">
            <div className="feature-grid">
              <div className="feature-card">
                <div className="feature-icon">🎯</div>
                <h3>Comprehensive Implementation</h3>
                <p>Full teacher professional development and parent workshop programs tailored to your school's needs.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">👥</div>
                <h3>Enhanced Support</h3>
                <p>Dedicated implementation specialist and ongoing coaching throughout the program duration.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">📊</div>
                <h3>Research Partnership</h3>
                <p>Collaborate with our research team to measure outcomes and contribute to the evidence base.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">💰</div>
                <h3>Significant Savings</h3>
                <p>Receive up to 50% discount on program fees in exchange for research participation.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Program Benefits */}
      <section className="section section-light">
        <div className="container">
          <div className="benefits-content">
            <div className="benefits-text">
              <h2>Why Join Our Pilot Program?</h2>
              <div className="benefits-list">
                <div className="benefit-item">
                  <div className="benefit-icon">✓</div>
                  <div className="benefit-content">
                    <h4>Be a Pioneer</h4>
                    <p>Lead the way in digital wellness education and become a model for other schools.</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">✓</div>
                  <div className="benefit-content">
                    <h4>Enhanced Resources</h4>
                    <p>Access to exclusive materials, tools, and ongoing program updates.</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">✓</div>
                  <div className="benefit-content">
                    <h4>Research Recognition</h4>
                    <p>Potential inclusion in published research and case studies (with permission).</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">✓</div>
                  <div className="benefit-content">
                    <h4>Network Access</h4>
                    <p>Connect with other pilot schools and share best practices.</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">✓</div>
                  <div className="benefit-content">
                    <h4>Priority Support</h4>
                    <p>Direct access to our implementation team for questions and guidance.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="benefits-image">
              <img src={teacherImage} alt="Teacher working with engaged students" />
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section section-teal">
        <div className="container text-center">
          <h2 style={{color: 'white', marginBottom: '1rem'}}>Ready to Lead the Way?</h2>
          <p style={{color: 'white', fontSize: '1.2rem', marginBottom: '2rem'}}>
            Applications are reviewed on a rolling basis. Don't miss this opportunity to be at the 
            forefront of digital wellness in education.
          </p>
          <button className="btn btn-secondary" onClick={() => onNavigate('contact')}>
            Apply for the Pilot Program
          </button>
        </div>
      </section>
    </div>
  );
};

export default PilotProgramPage;
